import Vue from 'vue'
let manager_list = JSON.parse(document.getElementById('manager_list').textContent);
new Vue({
    el: '#management-vision',
    name: 'management-vision',
    delimiters: ['${', '}'],
    store: window.store,
    data: {
        manager_list,
        now_data:manager_list[0],
        show_data:manager_list[0][0]
    },
    methods: {
        changeData(item){
            this.show_data = item;
            document.getElementById('d_info').classList.add('_active');
        },
        infoRemoveShow(){
            document.getElementById('d_info').classList.remove('_active');
        }
    },
    mounted() {
        document.getElementById('tab1-1').classList.add('active');
    },
    watch: {
        now_data(newName, oldName) {
            this.infoRemoveShow();
            this.show_data = newName[0];
        }
    }
})